import script from "./IconPower4.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconPower4.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__